module.exports = __webpack_public_path__ + "static/media/santander.046fdea7.svg";